import React, { useState, useEffect } from 'react';
import uploadIcon from "../assets/images/upload-icon.png";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from 'react-i18next';

export default function ImageForm(props) {
  const { t } = useTranslation();

  const {
    setLogo,
    setLogoFile,
    setSplash,
    setSplashFile,
    setBackgroundImg,
    setBackgroundImgFile,
    setAndriodIcon,
    setAndriodIconFile,
    setAppleIcon,
    setAppleIconFile,
    setNotificationIcon,
    setNotificationIconFile,
    resetChildState,
    setResetChildState
  } = props;
 
  const [splashName, setSplashName] = useState(null);
  const [logoName, setLogoName] = useState(null);
  const [backgroundImgName, setBackgroundImgName] = useState(null);
  const [appleImgName, setAppleImgName] = useState(null);
  const [andriodImgName, setAndriodImgName] = useState(null);
  const [notificationImgName, setNotificationName] = useState(null);

  useEffect(() => {
    if (resetChildState) {
      setSplashName(null);
      setLogoName(null);
      setBackgroundImgName(null);
      setAppleImgName(null);
      setAndriodImgName(null);
      setNotificationName(null);
      setResetChildState(false);
    }
  }, [resetChildState]);

  // Function to handle validation on user uploaded image size
  const handleImageChange = (event, height, width, setImage, setName, type) => {

    const file = event.target.files[0];
    const parentNode = event.target.parentNode;

    if (file) {
      // Check if the file is a PNG image
      if (file.type === "image/png") {
        
        if (type === 'appleIcon') {

          setAppleIconFile(file);

        } else if (type === 'androidIcon') {

          setAndriodIconFile(file);

        } else if (type === 'notificationIcon') {

          setNotificationIconFile(file);

        } else if (type === 'splash') {

          setSplashFile(file);

        } else if (type === 'backgroundImage') {

          setBackgroundImgFile(file);

        }

        const img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload = () => {

          // Check if the image meets your height and width requirements
          if (img.width == width && img.height == height) {
            // If it meets the requirements, get the URL or base64 data
            const imageURL = URL.createObjectURL(file);

            // Set the image URL and name in the state
            setImage(imageURL);
            setName(file.name);

            // Add or remove the 'error' class based on the condition
            parentNode.classList.remove("error");
          } else {
            // If it doesn't meet the requirements, add the 'error' class and display an alert
            parentNode.classList.add("error");
            toast.error(
              // `Please upload an image with dimensions less than or equal to ( height: ${height} x width: ${width} ). Your dimensions are ( height: ${img.height} x width:${img.width} )`
              `אנא העלו את התמונות במידות הנדרשות (המידות כתובות מתחת לשדות בהם מזינים את התמונה)`
            );
          }
        };
      } else {
        parentNode.classList.add("error");
        // If the file is not a PNG image, show a toast notification
        toast.error("Please upload a PNG image.");
      }
    }
  };

  const handleLogoChange = (event) => {
    const parentNode = event.target.parentNode;
    const file = event.target.files[0];
    if (file) {
      if (file.type === "image/png") { 
        setLogoFile(file);
        const reader = new FileReader();
        reader.onload = (e) => {
          setLogo(e.target.result);
          setLogoName(file.name);
        };
        reader.readAsDataURL(file);
      } else {
        parentNode.classList.add("error");
        // If the file is not a PNG image, show a toast notification
        toast.error("Please upload a PNG image.");
      }
    }
  };

  return (
    <div className="form-wrapper upload-images-wrap">
      <div className="input-col-wrapper">
        <div className="input-wrapper">
          <label>{t('firstFileInputTitle')}</label>
          <div className="upload-input-wrapper">
            <label className="uploadFile">
              <span className="filename">{appleImgName}</span>
              <input
                type="file"
                accept="image/png"
                onChange={(e) =>
                  handleImageChange(
                    e,
                    1024,
                    1024,
                    setAppleIcon,
                    setAppleImgName,
                    'appleIcon'
                  )
                }
              />
            </label>

            <img src={uploadIcon} className="upload-icon" />
          </div>
          <span className="small">{t('firstFileInputPlaceholder')}</span>
        </div>

        <div className="input-wrapper">
          <label>{t('secondFileInputTitle')}</label>
          <div className="upload-input-wrapper">
            <label className="uploadFile">
              <span className="filename">{andriodImgName}</span>
              <input
                type="file"
                accept="image/png"
                onChange={(e) =>
                  handleImageChange(
                    e,
                    512,
                    512,
                    setAndriodIcon,
                    setAndriodImgName,
                    'androidIcon'
                  )
                }
              />
            </label>

            <img src={uploadIcon} className="upload-icon" />
          </div>
          <span className="small">{t('secondFileInputPlaceholder')}</span>
        </div>

        <div className="input-wrapper">
          <label>{t('thirdFileInputTitle')}</label>
          <div className="upload-input-wrapper">
            <label className="uploadFile">
              <span className="filename">{notificationImgName}</span>
              <input
                type="file"
                accept="image/png"
                onChange={(e) =>
                  handleImageChange(
                    e,
                    96,
                    96,
                    setNotificationIcon,
                    setNotificationName,
                    'notificationIcon'
                  )
                }
              />
            </label>

            <img src={uploadIcon} className="upload-icon" />
          </div>
          <span className="small">{t('thirdFileInputPlaceholder')}</span>
        </div>

        <div className="input-wrapper">
          <label>
            {t('fourthFileInputTitle')}
          </label>
          <div className="upload-input-wrapper">
            <label className="uploadFile">
              <span className="filename">{splashName}</span>
              <input
                type="file"
                accept="image/png"
                onChange={(e) =>
                  handleImageChange(e, 2436, 1242, setSplash, setSplashName, 'splash')
                }
              />
            </label>
            <img src={uploadIcon} className="upload-icon" />
          </div>
          <span className="small">{t('fourthFileInputPlaceholder')}</span>
        </div>

        <div className="input-wrapper">
          <label>
            {t('fifthFileInputTitle')}
          </label>
          <div className="upload-input-wrapper">
            <label className="uploadFile">
              <span className="filename">{logoName}</span>
              <input
                type="file"
                accept="image/png"
                onChange={handleLogoChange}
              />
            </label>

            <img src={uploadIcon} className="upload-icon" />
          </div>
          <span className="small">{t('fifthFileInputPlaceholder')}</span>
        </div>

        <div className="input-wrapper">
          <label> {t('sixthFileInputTitle')} </label>
          <div className="upload-input-wrapper">
            <label className="uploadFile">
              <span className="filename">{backgroundImgName}</span>
              <input
                type="file"
                accept="image/png"
                onChange={(e) =>
                  handleImageChange(
                    e,
                    500,
                    1024,
                    setBackgroundImg,
                    setBackgroundImgName,
                    'backgroundImage'
                  )
                }
              />
            </label>

            <img src={uploadIcon} className="upload-icon" />
          </div>
          <span className="small">{t('sixthFileInputPlaceholder')}</span>
          <ToastContainer />
        </div>
      </div>
    </div>
  );
}
